<template>
  <div class="form-box">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="农场名称" prop="farmName" required>
        <span class="form-txt">{{ ruleForm.farmName }}</span>
      </el-form-item>
      <el-form-item label="农事类型" prop="sysMissionCategoryName" required>
        <span class="form-txt">{{ ruleForm.sysMissionCategoryName }}</span>
      </el-form-item>
      <el-form-item label="种类" prop="cropName" required>
        <span class="form-txt">{{ ruleForm.cropName }}</span>
      </el-form-item>
      <el-form-item label="品种" prop="cropBreed">
        <el-input
          v-model="ruleForm.cropBreed"
          maxlength="20"
          placeholder="请输入内容"
        ></el-input>
      </el-form-item>
      <el-form-item label="地块" prop="landIds">
        <el-button
          v-if="!ruleForm.landIds.length"
          round
          size="medium"
          class="select-btn"
          @click="chooseLandHandle"
          >选择地块</el-button
        >
        <el-button
          v-else
          round
          size="medium"
          type="text"
          @click="chooseLandHandle"
        >
          {{
            `已选择${ruleForm.landIds.length}个地块(共${ruleForm.landAcre}亩)`
          }}
        </el-button>
      </el-form-item>
      <el-form-item label="种植标准" prop="plantStandardId" required>
        <ul class="breed_level">
          <li
            :class="[
              'item',
              ruleForm.plantStandardId == item.id ? 'selected' : '',
            ]"
            v-for="item in standardList"
            :key="item.id"
            @click="
              () => {
                ruleForm.plantStandardId = item.id;
              }
            "
          >
            <img :src="item.plantStandardImgUrl" alt="" />
            <p>{{ item.plantStandardName }}</p>
          </li>
        </ul>
      </el-form-item>
      <el-form-item label="种植方式" prop="plantMethod">
        <el-radio-group v-model="ruleForm.plantMethod">
          <el-radio
            disabled
            v-for="item in plantMethodArr"
            :key="item.label"
            :label="item.label"
            >{{ item.value }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item label="作业方式" prop="operationMode">
        <el-radio-group v-model="ruleForm.operationMode">
          <el-radio
            v-for="item in operationModeArr"
            :key="item.label"
            :label="item.label"
            >{{ item.value }}</el-radio
          >
        </el-radio-group>
      </el-form-item>
      <el-form-item
        :label="`${ruleForm.plantMethod === 1 ? '移栽' : '播种'}时间`"
        prop="plantStartDateStr"
      >
        <el-date-picker
          v-model="ruleForm.plantStartDateStr"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerDateOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="预计采收时间" prop="pickMonthStr">
        <el-date-picker
          v-model="ruleForm.pickMonthStr"
          type="month"
          placeholder="选择月"
          value-format="yyyy-MM"
          :picker-options="pickerMonthOptions"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="预计亩产" prop="forecastOutputAcre">
        <el-input
          placeholder=""
          maxlength="9"
          v-model="ruleForm.forecastOutputAcre"
        >
          <template slot="append">公斤/亩</template>
        </el-input>
      </el-form-item>
      <div class="batch-morebtn" v-if="!showMore">
        <p class="more" @click="showMore = true">
          <span>更多</span>
          <i class="iconfont icon-icon-toolbar-sys-more"></i>
        </p>
      </div>
      <template v-if="showMore">
        <el-form-item label="株数" prop="plantNum">
          <el-input placeholder="" maxlength="9" v-model="ruleForm.plantNum">
            <template slot="append">{{ cropUnit }}</template>
          </el-input>
        </el-form-item>
        <el-form-item label="株间距" prop="plantSpacingRow">
          <el-input
            placeholder=""
            maxlength="9"
            v-model="ruleForm.plantSpacingRow"
          >
            <template slot="append">cm</template>
          </el-input>
        </el-form-item>
      </template>
      <!-- 农机信息 -->
      <agric-info :agricInfo="njList"></agric-info>
      <!-- 提交按钮 -->
      <form-btn @submitForm="submitForm" @deleteForm="deleteForm"></form-btn>
    </el-form>
    <!-- 地块 -->
    <div class="land-shade" v-if="showLand && !closeOpen"></div>
    <div v-if="showLand && !closeOpen" class="land-content">
      <div class="land-content-list">
        <choose-land
          :selectLandLists="selectLandLists"
          :selectCropGroupId="'empty'"
          @submit="chooseLandFun"
          @selectLandList="selectLandList"
        ></choose-land>
      </div>
      <button class="close-btn" @click="closeHandle">
        <img src="@/assets/images/common/bg-close.png" alt="" />
      </button>
    </div>
  </div>
</template>

<script>
import FormBtn from "../components/FormBtn";
import ChooseLand from "../ChooseLand/Index.vue";
import AgricInfo from "../components/AgricInfo";
import { getStorage } from "@/utils/storage";
import { mapState, mapGetters } from "vuex";
import {
  getPlantStandardList,
  getDetail,
  saveMission,
  saveAndAudit,
  getDel,
} from "@/api/request/snkd.produce";
export default {
  name: "SeedingForm",
  components: {
    FormBtn,
    ChooseLand,
    AgricInfo,
  },
  props: {
    isBack: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isBack(val) {
      if (val) {
        const ruleForm = {
          ...this.ruleForm,
          selectLandLists: this.selectLandLists,
        };
        if (JSON.stringify(this.originForm) === JSON.stringify(ruleForm)) {
          this.$router.go(-1);
        } else {
          const h = this.$createElement;
          this.$confirm("", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            customClass: "confirm-dialog",
            message: h("div", [
              h(
                "p",
                {
                  style:
                    "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
                },
                `当前页面未保存！`
              ),
              h(
                "p",
                {
                  style:
                    "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
                },
                [
                  h(
                    "span",
                    null,
                    "是否确定返回？返回后将不对修改后的数据进行保存"
                  ),
                ]
              ),
            ]),
            type: "warning",
          })
            .then(async () => {
              this.$router.go(-1);
            })
            .catch(() => {
              this.$emit("updateStatus", false);
            });
        }
      }
    },
  },
  data() {
    const _this = this;
    return {
      curId: "",
      farmId: "",
      companyId: "",
      categoryType: "", // 农事id
      selectLandLists: [],
      showLand: false,
      cropUnit: "株", //株数单位
      showMore: false, //是否展示更多
      njList: [], //农机信息
      originForm: {}, //原始数据
      ruleForm: {
        cropId: "",
        cropName: "",
        farmName: "",
        // sysMissionCategoryId: "1",
        sysMissionCategoryName: "",
        cropBreed: "",
        landIds: [],
        landAcre: "",
        plantStandardId: "4", //种植标准
        operationMode: 0, //作业方式
        plantMethod: 1, //种植方式
        plantStartDateStr: "", //移栽日期/直播时间/预苗时间
        pickMonthStr: "", //采收时间
        forecastOutputAcre: "", // 预计亩产
        plantNum: "", //移栽株数/育苗株数/直播株数
        plantSpacingRow: "", //株间距
        // plantSpacingUnit: 1, //株间距单位,1-cm，10-dm，100-m
      },
      standardList: [], //种植标准列表
      rules: {
        landIds: [{ required: true, message: "请选择地块", trigger: "blur" }],
        operationMode: [
          { required: true, message: "请选择作业方式", trigger: "change" },
        ],
        plantMethod: [
          { required: true, message: "请选择种植方式", trigger: "change" },
        ],
        plantStartDateStr: [
          { required: true, message: "请选择移栽时间", trigger: "blur" },
        ],
        forecastOutputAcre: [
          { pattern: /^[1-9]\d*$/, message: "请输入正整数" },
        ],
        plantNum: [{ pattern: /^[1-9]\d*$/, message: "请输入正整数" }],
        plantSpacingRow: [{ pattern: /^[1-9]\d*$/, message: "请输入正整数" }],
      },
      operationModeArr: [
        {
          label: 0,
          value: "人工",
        },
        {
          label: 1,
          value: "机械",
        },
      ],
      plantMethodArr: [
        { label: 1, value: "移栽" },
        // { label: 2, value: "育苗" },
        { label: 3, value: "直播" },
      ],
      pickerDateOptions: {
        disabledDate(time) {
          const newDate = new Date(_this.ruleForm.pickMonthStr);
          const year = newDate.getFullYear();
          const month = newDate.getMonth() + 1;

          if (_this.ruleForm.pickMonthStr) {
            return (
              time.getTime() > new Date(year, month, 0).getTime() ||
              time.getTime() > Date.now()
            );
          } else {
            return time.getTime() > Date.now();
          }
        },
      },
      pickerMonthOptions: {
        disabledDate(time) {
          if (_this.ruleForm.plantStartDateStr) {
            // return time.getTime() < _this.ruleForm.plantStartDateStr;
            return (
              time.getTime() <
              new Date(_this.ruleForm.plantStartDateStr).getTime()
            );
          } else {
            return false;
          }
        },
      },
    };
  },
  mounted() {
    this.curId = this.$route.query.id;
    //获取农场id
    const farminfo = getStorage("FARMINFO");
    if (getStorage("FARMINFO")) {
      this.companyId = farminfo.companyId;
      this.farmId = farminfo.farmId;
    }
    this.getPlantStandardList();
    this.getDetail();
  },
  computed: {
    ...mapState("damage", {
      closeOpen: "closeOpen",
    }),
    ...mapGetters("damage", ["hadSelectedLandList", "showLandList"]),
    //求和
    totalAcre() {
      return this.calcLandAcre(this.selectLandLists);
    },
  },
  methods: {
    submitForm(type) {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          console.log("校验通过");
          this.saveForm(type);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /**
     * type: 1、保存 2、保存并提交审核
     */
    async saveForm(type) {
      let params = {
        categoryType: this.categoryType,
        id: this.curId,
        operationMode: this.ruleForm.operationMode,
        landIds: this.ruleForm.landIds,
        planStashVO: {
          cropId: this.ruleForm.cropId,
          cropBreed: this.ruleForm.cropBreed,
          cropName: this.ruleForm.cropName,
          forecastOutputAcre: this.ruleForm.forecastOutputAcre,
          operationMode: this.ruleForm.operationMode,
          pickMonthStr: this.ruleForm.pickMonthStr,
          plantMethod: this.ruleForm.plantMethod,
          plantNum: this.ruleForm.plantNum,
          plantSpacingRow: this.ruleForm.plantSpacingRow,
          plantStandardId: this.ruleForm.plantStandardId,
          plantStartDateStr: this.ruleForm.plantStartDateStr,
          plantPlanModel: 0, //默认否
          uploadBlockchain: 0, //默认否
        },
      };
      console.log("params", params, type === 1, typeof type);
      if (type === 1) {
        await saveMission(params).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.$message.success("保存成功");
            this.$router.go(-1);
          }
          console.log(respCode, obj);
        });
      } else {
        await saveAndAudit(params).then((res) => {
          const { respCode, obj } = res;
          if (respCode === 0) {
            this.$message.success("提交审核成功");
            this.$router.go(-1);
          } else if (respCode === 40012) {
            // 审核不成功
            this.auditFail();
          }
          console.log(respCode, obj);
        });
      }
    },
    async getDetail() {
      await getDetail({
        id: this.curId,
        companyId: this.companyId,
      }).then((res) => {
        const { respCode, obj } = res;
        console.log(respCode, obj);

        if (respCode === 0) {
          this.categoryType = obj.categoryType;
          this.ruleForm.farmName = obj.farmName;
          this.ruleForm.sysMissionCategoryName = obj.sysMissionCategoryName;
          this.ruleForm.cropBreed = obj.planStashVO.cropBreed || "";

          this.ruleForm.plantMethod = obj.planStashVO.plantMethod;
          this.ruleForm.plantStandardId = obj.planStashVO.plantStandardId;
          this.ruleForm.operationMode = obj.planStashVO.operationMode;
          this.ruleForm.pickMonthStr = obj.planStashVO.pickMonthStr;
          this.ruleForm.plantSpacingRow = obj.planStashVO.plantSpacingRow || "";
          this.ruleForm.plantStartDateStr = obj.planStashVO.plantStartDateStr;
          this.ruleForm.plantNum = obj.planStashVO.plantNum || "";
          this.ruleForm.cropId = obj.planStashVO.cropId;
          this.ruleForm.cropName = obj.planStashVO.cropName;

          this.ruleForm.forecastOutputAcre =
            obj.planStashVO.forecastOutputAcre || "";
          //地块
          this.selectLandLists = obj.landList;
          this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
          this.ruleForm.landAcre = this.calcLandAcre(this.selectLandLists);

          //删除农机信息的第一条数据
          this.njList = obj.njList || [];
        }
        let originForm = {
          ...this.ruleForm,
          selectLandLists: this.selectLandLists,
        };
        this.originForm = JSON.parse(JSON.stringify(originForm));
      });
    },
    auditFail() {
      const h = this.$createElement;
      this.$confirm("", {
        confirmButtonText: "知道了",
        showCancelButton: false,
        customClass: "confirm-dialog",
        message: h("div", [
          h(
            "p",
            {
              style:
                "font-size: 16px;margin-bottom:12px;color: rgba(0, 0, 0, 0.85);font-weight:400;",
            },
            `审核未通过！`
          ),
          h(
            "p",
            {
              style:
                "font-size: 14px;color: rgba(0, 0, 0, 0.65);font-weight:400;",
            },
            [h("span", null, "当前数据未审核成功，请手动重新审核。")]
          ),
        ]),
        type: "warning",
      })
        .then(() => {})
        .catch(() => {});
    },
    getPlantStandardList() {
      const params = {
        companyId: this.companyId,
      };
      getPlantStandardList(params).then((res) => {
        const { respCode, obj } = res;
        if (respCode === 0) {
          this.standardList = obj.list.filter((item) => item.id !== 3) || [];
        }
      });
    },
    selectLandList(evt) {
      this.selectLandLists = evt;
    },
    //打开地块弹框
    chooseLandHandle() {
      this.$store.commit("damage/closeLand", false);
      this.$store.commit("damage/changeShowLandMode", "ListMode");
      this.showLand = true;
    },
    // 地块选择确定
    chooseLandFun() {
      this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
      this.ruleForm.landAcre = this.totalAcre;
    },
    //关闭地块弹框
    closeHandle() {
      this.showLand = false;
      this.ruleForm.landIds = this.selectLandLists.map((item) => item.id);
      this.ruleForm.landAcre = this.totalAcre;
      //清空筛选条件
      this.$store.commit("damage/clearPageAllStatus");
    },
    //求和
    calcLandAcre(list) {
      const countStr = list
        .reduce((total, cur) => {
          if (cur.statisticsLandAcre) {
            return total + cur.statisticsLandAcre;
          } else {
            return total + cur.landAcre;
          }
        }, 0)
        .toFixed(2);
      return parseFloat(countStr);
    },
    async deleteForm() {
      await getDel({
        idList: [this.curId],
      }).then((res) => {
        const { respCode } = res;
        if (respCode === 0) {
          this.$message({
            type: "success",
            message: "删除成功！",
          });
          this.$router.go(-1);
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.form-box {
  background: #fff;
  ::v-deep .demo-ruleForm {
    padding: 40px;
    width: 560px;
    margin: 0 auto;
    .form-txt {
      color: #c0c4cc;
    }
    .select-btn {
      border: 1px solid #64c3a4;
      color: #64c3a4;
    }
    .batch-morebtn {
      font-size: 16px;
      color: #333333;
      margin: 40px 0 115px;
      margin-left: 64px;
      .more {
        cursor: pointer;
        display: inline-block;
      }
      .more:hover {
        color: #64c3a4;
        .iconfont {
          color: #64c3a4;
        }
      }
      .iconfont {
        margin: 0 4px;
        vertical-align: -1px;
        margin-left: 9px;
        color: #888888;
      }
    }
    .breed_level {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .item {
        cursor: pointer;
        font-size: 14px;
        color: #666;
        margin: 0 16px 0 0;
        width: 80px;
        height: 80px;
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-flow: column;
        margin-bottom: 10px;
        img {
          width: 40px;
        }
        p {
          margin-top: 6px;
          height: 20px;
          line-height: 20px;
        }
      }
      .selected {
        border: 1px solid #64c3a4;
        background: url("../../../assets/images/aviatFarmingList/selected-ico.png")
          no-repeat right 59px;
      }
    }
    .el-input-group__append {
      width: 90px;
      box-sizing: border-box;
      text-align: center;
    }
    .el-date-editor {
      width: 100%;
    }
    .el-button--medium.el-button--text {
      padding: 0;
    }
  }
  .land-shade {
    width: 100%;
    height: 100%;
    background-color: rgb(0, 0, 0);
    opacity: 0.3;
    z-index: 5;
    position: absolute;
    top: 0px;
    left: 0;
  }
  .land-content {
    position: absolute;
    top: 13%;
    left: 0;
    right: 0;
    width: 1200px;
    height: 85%;
    z-index: 10;
    margin: 0 auto;
    .land-content-list {
      width: 100%;
      height: 95%;
      background-color: #fff;
      margin: 0 auto;
      border-radius: 10px;
      padding: 10px;
      position: relative;
    }
    .close-btn {
      position: absolute;
      right: -5%;
      top: 0;
      height: 36px;
      width: 36px;
      border: 2px solid #fff;
      border-radius: 50%;
      outline: 0;
      background-color: rgb(0, 0, 0);
      opacity: 0.2;
      cursor: pointer;
      img {
        vertical-align: middle;
      }
    }
  }
  .land-select {
    font-size: 14px;
    font-weight: 400;
    color: #64c3a4;
    cursor: pointer;
  }
}
</style>
